import axios from '../index'

export default {
    getInstituciones () {
        return axios.get('/instituciones/usuario/')
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    getPrograma (institucionId) {
        return axios.get('/programas/institucion/'+ institucionId)
    },
}